import { Component, OnInit } from '@angular/core';
//import { AdataService } from '../../shared/adata.service';
import { NgForm} from '@angular/forms';
import { ThrowStmt } from '@angular/compiler';
import { DatePipe } from '@angular/common';
import { UserService } from '../../shared/user.service';
import { Alert } from 'selenium-webdriver';
import swal from 'sweetalert2';



@Component({
  selector: 'app-account-closure',
  templateUrl: './account-closure.component.html',
  styleUrls: ['./account-closure.component.css']
})
export class AccountClosureComponent implements OnInit {
  transopt:any={};
  tra:any=[];
  display='none';
  disaccdata:any;
  disacopt:any={};
  da:any=[];
  notaccno:any;
  title = "Account Closure"
  actydata: any;
  actopt: any;
  tschopt: any;
  ac:any={};
  sc:any=[];
  acschdata: any;
  schopt: any;
  formpigmypart:any={};
  glsubid:number;
  accno: any;
  acglsubid:any;
  branchdt: any;
  brnchopt:any=[];
  b :any={};
  pigmydata: any;
  pigopt: any;
  pg:any={};
  formpigmypartge: any={};
  today = new Date();  
  DateValues:string;
  calculated:number;
  ischeckd:boolean;
  ischeckm:boolean;
  nullzero:number=0;
  bool_p: boolean;
  bool_m:boolean;
  lblcurint:string;
  diffbasedmonths:any;

  transactype:number;
  transacscheme:number;
  transamt:number;
  transacno:string;
  transtoken_Ref:number;
  transnarration:string;
  transname:string;
  logbranch: string;
  commonUrl: string;
  userName: string;
  LBLPRECLOSEINT:string;
  lblInt:string;
  lblaccumulated:string;
  Actual:string;
  Interest:string;
  form: string;
  l_codepigmydata: any;


  constructor(private service:UserService,private datePipe : DatePipe) 
  {
    this.logbranch=localStorage.getItem('BRANCH_ID');
    this.commonUrl = service.rootUrl;
    this.userName = localStorage.getItem('userName');
    this.lblcurint="Interest Amt (Current)";
    this.LBLPRECLOSEINT="Reduced Rate";
    this.lblInt="Intrest accumulated";
    this.lblaccumulated="Intrest accumulated";
    this.Actual="Actual";
    this.Interest="Interest";
    this.form="Pigmy_Deposit";
   }

  ngOnInit() 
  {
   // this.actype();
    this.getbranchd();
    this.getpigmylcode();
    this.acscheme(3);
  
  }
  getpigmylcode()
  {
    debugger;
      this.l_codepigmydata=this.service.getpigmylcode(this.logbranch);
      this.l_codepigmydata.subscribe(
        (pigmylcodeResponse:any)=>{
            console.log(pigmylcodeResponse);
            this.acsetbranch(this.logbranch);
            this.acgetsub(pigmylcodeResponse.GLSUB_ID);
        }
      )
  }

  actype()
  {
    this.actydata=this.service.gettrans();
    this.actydata.subscribe(
      (actyres:any)=>{
        this.actopt=actyres;
        console.log(this.actopt);
      }
    )
  }
  acscheme(module:number)
  {
    this.acschdata=this.service.getscheme(module);
    this.acschdata.subscribe(
      (schres:any)=>
      {
        this.schopt=schres;
        console.log(this.schopt);
      }
    )
  }
  acgetsub(schnum: any)
  {
    debugger;
    if(schnum.length==1)
    {
      this.formpigmypart.glsubid='00'+schnum;
    }
    else if(schnum.length==2)
    {
      this.formpigmypart.glsubid='0'+schnum;
    }
    else if(schnum.length==3)
    {
      this.formpigmypart.glsubid=schnum;
    } //this.acglsubid= new string.concat(0,this.schnum);
    
  }

  getbranchd()
  {
    debugger
  let BRANCH_ID=localStorage.getItem('BRANCH_ID');
   this.branchdt=this.service.getbranch();
   this.branchdt.subscribe(
    (bresponse:any)=>{
     // this.formpigmypart.branchsel=BRANCH_ID;
       this.brnchopt=bresponse.BranchModels;
     // for(let i=0;i<bresponse.BranchModels.length;i++){
      // if(BRANCH_ID==bresponse.BranchModels[i].BRANCH_ID){
       //   this.brnchopt.push(bresponse.BranchModels[i]);
      //  }
    //  }
      
     // this.acsetbranch(BRANCH_ID);
      
    })
  }

  acsetbranch(bid:any)
  {
    this.formpigmypart.tbranchsel=bid;
    if(bid.length==1)
    {
      this.formpigmypart.branch='00'+bid;
      this.formpigmypart.tacbranch='00'+bid;
    }
    else if(bid.length==2)
    {
      this.formpigmypart.branch='0'+bid;
      this.formpigmypart.tacbranch='0'+bid;
    }
    else if(bid.length==3)
    {
      this.formpigmypart.branch=bid;
      this.formpigmypart.tacbranch=bid;
    }
  }

  tsetsubid(glsid:any)
 {
  if(glsid.length==1)
    {
      this.formpigmypart.tglsubid='00'+glsid;
    }
    else if(glsid.length==2)
    {
      this.formpigmypart.tglsubid='0'+glsid;
    }
    else if(glsid.length==3)
    {
      this.formpigmypart.tglsubid=glsid;
    } 
 }

  aonKey(branch:any,yrnd:any,acn:any,subid:any) { // without type info
  
    this.accno = branch+yrnd+acn+subid;    //event.target.value + ' | ';
    console.log(this.accno);
    this.pigmyaccountfetch(this.accno,subid,branch);

  }

 

  bindingtoform(res:any)
  {

    console.log(res);
    this.formpigmypart.CUSTID=res.txtcustid;  
    this.formpigmypart.ACC_ID=res.accid;  
      
    this.formpigmypart.OPEN_DT=this.getdatefun(res.TxtOpdt); //res.OPEN_DT; 
    this.formpigmypart.NAME=String(res.txtName);
    this.formpigmypart.INT_RATE=res.txtACtIntRate;
    this.formpigmypart.CARYF_BAL=res.txtCFBal;
    this.formpigmypart.BEF_BAL=res.TXTBFBAL;
    
    this.formpigmypart.PRIN_BAL=res.txtprinRepayAmt;
    this.formpigmypart.DEP_BAL=res.txtDpAmt;
    this.formpigmypart.Actul_INT=res.INT_RATE;
    this.formpigmypart.MAT_DT=  this.datePipe.transform(res.TxtMatDt,'yyyy-MM-dd');//this.getdatefun(res.END_DT);  //res.END_DT; 
    this.formpigmypart.REPAY_DT=this.getdatefun(this.today);    //this.today; //
    this.formpigmypart.strlidt=this.getdatefun(res.txtLastDt);   // res.LAST_INTDT; //
    this.formpigmypart.MCODE=res.MCODE;
    this.formpigmypart.INT_AMT=res.Txtinterest;
    this.formpigmypart.Loan_less=res.txtLessLoan;
    this.formpigmypart.NET_BAL=res.txtTransamt;
    this.formpigmypart.MAT_AMT=res.txtMatAmount;
    this.formpigmypart.REF_RATE=res.txtPreMatIntRate;
    this.formpigmypart.MIN_REQ=res.Txtminbal;
    this.formpigmypart.CARYF_BAL=res.txtCFBal;
    this.formpigmypart.INT_PAY=res.txtIntDrawn;
    this.formpigmypart.NET_INT=res.txtIntComAmt;
    this.formpigmypart.TOT_AMT=res.txtIntComAmt;
    this.formpigmypart.INTrest_PAY=res.txtIntPayable;
    this.formpigmypart.Actul_INT=res.txtIntRate;

    if( ((+res.txtprinRepayAmt)+(+res.Txtinterest)+(+res.txtLessLoan))==(+res.txtIntRate))
    this.formpigmypart.NET_BAL=res.txtTransamt;
    else
    this.formpigmypart.NET_BAL=(+res.txtprinRepayAmt)+(+res.Txtinterest)-(+res.txtLessLoan);

    if(res.lblcurint=="Comm Ded")
     {
      this.formpigmypart.INT_AMT=res.txtIntComAmt;
      this.formpigmypart.NET_BAL=(+res.txtprinRepayAmt)-(+res.txtIntComAmt)-(+res.txtLessLoan);
      this.lblaccumulated="Commission to deduct";
      this.Actual="Commision";
      this.LBLPRECLOSEINT="Commission Rate";
      this.lblcurint="Commission amt deduction";
      this.Interest="Commission";
     }
     else
     {
      //this.LBLPRECLOSEINT="Reduced Rate";
      this.lblaccumulated="Intrest accumulated";
      this.Interest="Intrest";
      this.lblcurint="Interest Amt (Current)";
     }
      
    //this.LBLPRECLOSEINT=res.LBLPRECLOSEINT;
    this.LBLPRECLOSEINT= res.LBLPRECLOSEINT!=""?res.LBLPRECLOSEINT:"Reduced Rate";
    this.lblInt=res.lblInt!=""?res.lblInt:"Intrest accumulated";
    
    

    if(res.PERIOD_D!==0)
    {  this.ischeckd=true;  }
    else
    {this.ischeckd=false;}
    if(res.PERIOD_M!==0)  
    {  this.ischeckm=true;  }
    else
    {this.ischeckm=false;}

    var d = new Date(res.TxtOpdt);
    var curr_date = d.getDate();
     var curr_month = d.getMonth() + 1; //Months are zero based
   var curr_year = d.getFullYear();
//  console.log(curr_year + "-/" + curr_month + "-/" + curr_date);
    var end_date=new Date(this.today);
    var ed_d = end_date.getDate();
    var ed_m = end_date.getMonth() + 1; //Months are zero based
    var ed_y = end_date.getFullYear();

    debugger;
    //var matur_dt= new Date(d.setMonth(d.getMonth() + res.PERIOD_M));
    //console.log(matur_dt);

 
    var diff = Math.abs(d.getTime() - end_date.getTime());
    var diffDays = Math.ceil((diff / (1000 * 3600 * 24))-1);

    // var diffMonth=Math.ceil((diff /30));
    // console.log(diffMonth);

debugger;
    var numberOfMonths = (curr_year - ed_y) * 12 + (curr_month - ed_m) ;
    var neutral=-0
    var num_m=-(neutral)-(numberOfMonths);
    console.log(numberOfMonths);
    console.log(num_m);

    this.formpigmypart.DAYSCOMP=diffDays;

    if (res.PERIOD_D!=0)
    {
      if(diffDays<=res.PERIOD_D)
        {
          this.bool_p=true;
          alert("Pre-Mature CLosure!");
          this.title="Account Closure::Pre-Mature Closure       'Days Based' ";
        }
      else
        {

        } 
    }
//preclosure monthly check
    if(res.PERIOD_M!=0)
    {   debugger;


    if(num_m<=res.PERIOD_M )
     {
      this.bool_m=true;
       alert("Pre-Matue Closure monthly based");
       this.title="Account Closure::Pre-Mature Closure       'Monthly Based'";
     }
    }

    console.log(diffDays);
  }

  // getadddate(dt:Date, add_month:number)
  // {debugger;
  //   var det=dt.getMonth();
  // return  new Date(dt.setMonth(dt.getMonth() + add_month));
 // }

  checkmonthdiff(dateFrom:Date, dateTo:Date) 
  {
    return dateTo.getMonth() - dateFrom.getMonth() + (12 * (dateTo.getFullYear() - dateFrom.getFullYear()));
  }
  
    getdatefun(indt:any)
    {
      this.DateValues=this.datePipe.transform(indt,'dd-MM-yyyy');
      console.log(this.DateValues);
      return this.DateValues;
   }
 
   calculnet(prin:number,intamt:number,loanamt:number,otheramt:number)
   {
     debugger;
     this.calculated=(+this.checknull(prin))+(+this.checknull(intamt))-(+this.checknull(loanamt))-(+this.checknull(otheramt));
     this.formpigmypart.NET_BAL=this.calculated;
     this.formpigmypart.tamt=this.calculated;
   
   }

   checknull(chknum:number)
   {
     debugger;
     if(chknum==null)
        return 0;
      else
        return chknum;
   }




   onSubmit(formpigmypart:NgForm)
  {
    debugger;
    if(formpigmypart.value.NET_BAL==0)
    {
        swal('Denied',"YOU CAN'T DO THIS TRANSACTION AS TRANSACTION AMOUNT IS LESS THAN ZERO(0).",'warning');
    }
    else
    {
      this.insertrecord(formpigmypart);  
    }
  }
  insertrecord(formpigmypart: NgForm)
  {
    debugger;
    formpigmypart.value.Me="";
    document.getElementById('loader-spinner').style.display = "block";
    this.service.PigmyClosure(formpigmypart.value).subscribe(res=>{
      this.resetForm(formpigmypart)
      document.getElementById('loader-spinner').style.display = "none";
      swal('Account Closed!', 'Account is Closed!', 'success');
     })

  }
  tacscheme(module:number)
  {
    debugger;
    this.acschdata=this.service.getscheme(module);
    this.acschdata.subscribe(
      (schres:any)=>
      {
        this.tschopt=Array.of(schres);
        console.log(this.schopt);
      }
    )
  }


  resetForm(form?: NgForm)
  {
    if(form!=null)
    {
      this.formpigmypart.CUSTID='';
      this.formpigmypart.OPEN_DT='';
      this.formpigmypart.NAME='';
      this.formpigmypart.INT_RATE=null;
      this.formpigmypart.CARYF_BAL=null;
      this.formpigmypart.BEF_BAL=null;
      this.formpigmypart.NET_BAL=null;
      this.formpigmypart.PRIN_BAL=null;
      this.formpigmypart.DEP_BAL=null;
      this.formpigmypart.Actul_INT=null;
      this.formpigmypart.MAT_DT='';
      this.formpigmypart.REPAY_DT='';
      this.formpigmypart.LAST_INTDT='';
      this.formpigmypart.MCODE='';
      
      this.formpigmypart.actype='';
      this.formpigmypart.acscheme='';
      this.formpigmypart.branchsel='';
      this.formpigmypart.transtype='';
      this.formpigmypart.strlidt='';

      this.formpigmypart.MAT_AMT=null;
      this.formpigmypart.REF_RATE=null;
      this.formpigmypart.MIN_REQ=null;
      this.formpigmypart.INTrest_PAY=null;
      this.formpigmypart.MIN_REQ=null;
      this.formpigmypart.INT_PAY=null;
      this.formpigmypart.NET_INT=null;
      this.formpigmypart.TOT_AMT=null;
      this.ischeckd=false;
      this.ischeckm=false;
      this.formpigmypart.branch=null;
      this.formpigmypart.yrnd=null;
      this.formpigmypart.accno=null;
      this.formpigmypart.glsubid=null;
      this.formpigmypart.DAYSCOMP=null;
      this.formpigmypart.ACC_ID=null;

      this.title="Account Closure";
  }
 }


 getnar(acno:string,glsubid:any,name:string)
 {
   debugger;
   var nar="By "+glsubid.substring(1,2)+acno.substring(8,6)+" / "+name;
    return nar;
 }

 bindtotable(tactype:number,tacscheme:number,tamt:number,tacbranch:string,tacyrnd:string,tacno:string,tglsubid:string,ttoken_Ref:number,tnarration:string,tname:string)
 {
   debugger;
   this.transactype=tactype;
   this.transacscheme=tacscheme;
   this.transamt=tamt;
   this.transacno=  tacbranch+tacyrnd+tacno+tglsubid;
   this.transtoken_Ref=ttoken_Ref; 
   this.transnarration=tnarration;
   this.transname=tname;
 }

 Getbynumber(accn:string,subid:number,branch:number)
 {
   debugger;
   for(let i=0;i< this.disacopt.length;i++)
   {
     if(this.disacopt[i].ACC_NO==accn)
     { debugger;
       let accnum=this.disacopt[i].ACC_NO;
       let acnaqm=this.disacopt[i].NAME;
       this.formpigmypart.branch=accnum.substring(0,3);
       this.formpigmypart.yrnd=accnum.substring(7,3);
       this.formpigmypart.accno=accnum.substring(13,7);
      // this.formpigmypart.glsubid=accnum.substring(16,13);
      debugger;
     //  console.log(accnum);
     //  console.log(" branch");
     //  console.log(accnum.substring(0,3));
     //  console.log("yr");
     //  console.log(accnum.substring(7,3));
     //  console.log("acc_no");
     //  console.log(accnum.substring(13,7));
     //  console.log("subid");
     //  console.log(accnum.substring(16,13));
       this.pigmyaccountfetch(accnum,subid,branch);
       this.closeModalDialog();
     }
   }
 }
 Getbyname(name:string,subid:number,branch:number)
 {debugger;
   for(let i=0;i< this.disacopt.length;i++)
   {
     if(this.disacopt[i].NAME==name)
     {
       debugger;
       let accnum=this.disacopt[i].ACC_NO;
       let acnaqm=this.disacopt[i].NAME;
       this.formpigmypart.branch=accnum.substring(0,3);
       this.formpigmypart.yrnd=accnum.substring(7,3);
       this.formpigmypart.accno=accnum.substring(13,7);
      // this.formpigmypart.glsubid=accnum.substring(16,13);
       this.pigmyaccountfetch(accnum,subid,branch);
       this.closeModalDialog();
     } 
   }

 }
 openModalDialog(){
  this.display='block'; //Set block css
}

closeModalDialog(){
this.display='none'; //set none css after close dialog
document.getElementById('loader-spinner').style.display = "none";
}

onKey(branch:any,yrnd:any,acn:any,subid:any,branch__id:number)
  {
    debugger;
    let branch_id=Number(branch);
  this.accno = this.checkstringnul(branch)+this.checkstringnul(yrnd)+this.checkstringnul(acn)+this.checkstringnul(subid);
  this.notaccno=this.checkstringnul(acn)+this.checkstringnul(subid);
    if(this.accno.length<16)
    {
      this.disaccdata=this.service.getallaccountunivers(this.notaccno,subid,branch_id);
      this.disaccdata.subscribe(
        (accres:any)=>{
          this.disacopt=accres;
          console.log(this.disacopt);
          this.openModalDialog();
        })
     
    }
  
    else
    {
      let str="empty";
      this.checkacc(this.accno,subid,branch);
    }
  }
  checkacc(acno:string,glsubid:number,brnchid:number)
{
  debugger;
  let me="empty";
  this.disaccdata=this.service.chckacc(acno,glsubid,brnchid,me);
  this.disaccdata.subscribe(
    (accres:any)=>{
      if(accres=="closed")
      {
        document.getElementById('loader-spinner').style.display = "none";
        this.clear();
        swal('Account Closed!','Account is already closed',"warning");
        
      }
      else
      {
        this.pigmyaccountfetch(acno,glsubid,brnchid);
      }
    })
}
pigmyaccountfetch(acno:string,glsubid:number,brnchid:number)
{
  document.getElementById('loader-spinner').style.display = "block";
  let me="empty";
  this.pigmydata=this.service.fetchpigmyaxno(acno,glsubid,brnchid,me);
  this.pigmydata.subscribe(
  (pigres:any)=>{
    this.pigopt=pigres;
    this.bindingtoform(pigres);
    this.transopt=pigres.newob;
    this.formpigmypart.tnarration=this.getnar(acno,glsubid,pigres.txtName);
    document.getElementById('loader-spinner').style.display = "none";
    
  })
}

  checkstringnul(str:string)
  {
    if(str!=null)
    {
      return str;
    }
    else
     return "";
  }

  productreport()
  {
    window.open(this.commonUrl+'/Reports/PigmyProduct/PigmyProductReport.aspx?userName='+this.userName);
  }
  clear()
  {
    this.formpigmypart.CUSTID='';
      this.formpigmypart.OPEN_DT='';
      this.formpigmypart.NAME='';
      this.formpigmypart.INT_RATE=null;
      this.formpigmypart.CARYF_BAL=null;
      this.formpigmypart.BEF_BAL=null;
      this.formpigmypart.NET_BAL=null;
      this.formpigmypart.PRIN_BAL=null;
      this.formpigmypart.DEP_BAL=null;
      this.formpigmypart.Actul_INT=null;
      this.formpigmypart.MAT_DT='';
      this.formpigmypart.REPAY_DT='';
      this.formpigmypart.LAST_INTDT='';
      this.formpigmypart.MCODE='';
      
      this.formpigmypart.actype='';
      this.formpigmypart.acscheme='';
      this.formpigmypart.branchsel='';
      this.formpigmypart.transtype='';
      this.formpigmypart.strlidt='';

      this.formpigmypart.MAT_AMT=null;
      this.formpigmypart.REF_RATE=null;
      this.formpigmypart.MIN_REQ=null;
      this.formpigmypart.INTrest_PAY=null;
      this.formpigmypart.MIN_REQ=null;
      this.formpigmypart.INT_PAY=null;
      this.formpigmypart.NET_INT=null;
      this.formpigmypart.TOT_AMT=null;
      this.ischeckd=false;
      this.ischeckm=false;
      this.formpigmypart.branch=null;
      this.formpigmypart.yrnd=null;
      this.formpigmypart.accno=null;
      this.formpigmypart.glsubid=null;
      this.formpigmypart.DAYSCOMP=null;
      this.formpigmypart.ACC_ID=null;

      this.title="Account Closure";
  }

}



// WEBPACK FOOTER //
// ./src/app/master-account/account-closure/account-closure.component.ts